import {
  init_utils
} from "./chunk-SBNKSDBP.mjs";
import {
  cn
} from "./chunk-CVRFJC2Q.mjs";
import {
  init_icons
} from "./chunk-BTTD2DGG.mjs";
import {
  Tick_default
} from "./chunk-HWQYTGRZ.mjs";
import {
  __objRest,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/components/checkbox/checkbox-v2.tsx
init_icons();
init_utils();
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import React from "react";
var CheckboxV2 = React.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React.createElement(
    CheckboxPrimitive.Root,
    __spreadValues({
      ref,
      className: cn(
        "peer h-5 w-5 shrink-0 rounded border border-bold focus-visible:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus disabled:cursor-not-allowed data-[state=checked]:bg-interactive-accent-surface-active data-[state=checked]:text-foreground-inverted data-[state=checked]:enabled:border-[theme(backgroundColor.interactive-accent-surface-active)] data-[state=checked]:disabled:border-[theme(backgroundColor.interactive-surface-disabled)] data-[state=checked]:disabled:bg-interactive-surface-disabled",
        className
      )
    }, props),
    /* @__PURE__ */ React.createElement(
      CheckboxPrimitive.Indicator,
      {
        className: cn("flex items-center justify-center text-current")
      },
      /* @__PURE__ */ React.createElement(Tick_default, { width: 18, height: 18 })
    )
  );
});

export {
  CheckboxV2
};
